import moment from "moment";

export const validatePhone = (phone) => {
  const re = /^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})-?(\d{4}))$/;
  return re.test(phone);
};

export const checkCNPJ = (cnpj) => {
  cnpj = cnpj.replace(/[^\d]+/g, "");

  if (cnpj === "") return false;

  if (cnpj.length !== 14) return false;

  // Elimina CNPJs invalidos conhecidos
  if (
    cnpj === "00000000000000" ||
    cnpj === "11111111111111" ||
    cnpj === "22222222222222" ||
    cnpj === "33333333333333" ||
    cnpj === "44444444444444" ||
    cnpj === "55555555555555" ||
    cnpj === "66666666666666" ||
    cnpj === "77777777777777" ||
    cnpj === "88888888888888" ||
    cnpj === "99999999999999"
  )
    return false;

  // Valida DVs
  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== parseInt(digitos.charAt(0))) return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== parseInt(digitos.charAt(1))) return false;

  return true;
};

export const checkCPF = (cpf) => {
  cpf = cpf.replace(/[^\d]+/g, "");
  if (cpf === "") {
    return false;
  }
  if (
    cpf.length !== 11 ||
    cpf === "00000000000" ||
    cpf === "11111111111" ||
    cpf === "22222222222" ||
    cpf === "33333333333" ||
    cpf === "44444444444" ||
    cpf === "55555555555" ||
    cpf === "66666666666" ||
    cpf === "77777777777" ||
    cpf === "88888888888" ||
    cpf === "99999999999"
  ) {
    return false;
  }
  let add = 0;
  for (let i = 0; i < 9; i++) add += parseInt(cpf.charAt(i)) * (10 - i);
  let rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(cpf.charAt(9))) {
    return false;
  }
  add = 0;
  for (let i = 0; i < 10; i++) add += parseInt(cpf.charAt(i)) * (11 - i);
  rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(cpf.charAt(10))) {
    return false;
  }
  return true;
};

export const checkHexColor = (color) => {
  if(color.slice(0, 1) !== "#"){
    return false;
  }
  const hex = color.slice(1).replace(/[^\d^(a-fA-F)]+/g, "");
  return hex.length === 6;
}

export const REQUIRED = (field, item) =>
  !item[field] || item[field] === "" || item[field] === 0
    ? "O valor é requerido"
    : null;

const validateEmail = (email) => {
  return email.match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
};

export const IS_DOCUMENT = (field, item) =>
  REQUIRED(field, item) || (!checkCPF(item[field]) && !checkCNPJ(item[field]))
    ? "O documento é inválido"
    : null;

export const IS_EMAIL = (field, item) =>
  !validateEmail(item[field]) ? "Informe um email válido." : null;

export const IS_UNIQUE = (checkFuntion) => async (field, item) => {
  let required = REQUIRED(field, item);
  if (required) {
    return required;
  }
  const id = await checkFuntion(item[field]);
  if (id && id !== item["id"]) {
    return "O valor informado já está em uso.";
  }
};

export const IS_VALID = (checkFuntion) => async (field, item) => {
  let required = REQUIRED(field, item);
  if (required) {
    return required;
  }
  const valid = await checkFuntion(item[field]);
  if (!valid) {
    return "O valor não é válido";
  }
};

export const AFTER_TODAY = (field, item) =>
  !!REQUIRED(field, item) || moment().diff(item[field].split("/").reverse(), "days") > 0
    ? "A data deve estar no futuro"
    : null;

export const BEFORE_TODAY = (field, item) => 
  !!REQUIRED(field, item) || moment().diff(item[field].split("/").reverse(), "days") < 0
    ? "A data deve estar no passado"
    : null;

export const BEFORE_DATE = (otherDateString) => (field, item) =>
  moment(item[field]).isBefore(moment(otherDateString))
    ? null
    : `A data deve ser anterior a ${moment(otherDateString).format("DD/MM/YYYY")}`;
  
export const BEFORE_OR_EQUAL_DATE = (otherDateString) => (field, item) =>
  !moment(item[field]).isAfter(moment(otherDateString))
    ? null
    : `A data deve ser anterior ou igual a ${moment(otherDateString).format("DD/MM/YYYY")}`;

export const AFTER_OR_EQUAL_DATE = (otherDateString) => (field, item) =>
  !moment(item[field]).isBefore(moment(otherDateString))
    ? null
    : `A data deve ser posterior ou igual a ${moment(otherDateString).format("DD/MM/YYYY")}`;

export const AFTER_DATE = (otherDateString) => (field, item) =>
  moment(item[field]).isAfter(moment(otherDateString))
    ? null
    : `A data deve ser posterior a ${moment(otherDateString).format("DD/MM/YYYY")}`;

export const LESS_THAN = (otherField, label) => (field, item) =>
  item[field] >= item[otherField]
    ? `O valor deve ser menor que ${label}`
    : null;

export const MORE_THAN = (otherField, label) => (field, item) =>
  item[field] <= item[otherField]
    ? `O valor deve ser maior que ${label}`
    : null;

export const MORE_THAN_VALUE = (min, minLabel) => (field, item) => {
  if(parseFloat(item[field]) < min){
    return `Valor menor que ${minLabel}`;
  }
  return null;
}

export const BETWEEN_VALUES = (min, max, minLabel, maxLabel) => (field, item) => {
  if(parseFloat(item[field]) < min){
    return `Valor menor que ${minLabel}`;
  } else if(parseFloat(item[field]) > max){
    return `Valor maior que ${maxLabel}`;
  }
  return null;
}

export const MORE_THAN_ZERO = (field, item) =>
  item[field] <= 0 ? "O valor deve ser maior que zero" : null;

export const AT_LEAST_ONE = (field, item) =>
  !item[field] || !Array.isArray(item[field]) || item[field].length === 0
    ? "É necessário adicionar ao menos um valor."
    : null;

export const validate = async (rules, item) => {
  let errors = {};
  const fields = Object.keys(rules);
  for (let i = 0; i < fields.length; i = i + 1) {
    let field = fields[i];
    let rule = rules[field];
    if (Array.isArray(rule)) {
      for (let j = 0; j < rule.length; j = j + 1) {
        let msg = await rule[j](field, item);
        if (msg) {
          errors[field] = msg;
          break;
        }
      }
    } else {
      let msg = await rule(field, item);
      if (msg) {
        errors[field] = msg;
      }
    }
  }
  return errors;
};

export const isValid = (errors) => Object.keys(errors).length === 0;
